import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=6b95bc8c&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"
import style0 from "./Logs.vue?vue&type=style&index=0&id=6b95bc8c&prod&scoped=true&lang=css"
import style1 from "./Logs.vue?vue&type=style&index=1&id=6b95bc8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95bc8c",
  null
  
)

export default component.exports